import { createSlice } from "@reduxjs/toolkit";

export const areaLevelSlice = createSlice({
    name: 'arealevel',
    initialState: {
        value: "province"
    },
    reducers: {
        setAreaLevel: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setAreaLevel } = areaLevelSlice.actions;

export const getAreaLevel = (state) => state.arealevel.value;

export default areaLevelSlice.reducer;